<template>
  <div v-if="button" class="p-3 mt-3 bg-white rounded p-3">
    <div class="d-flex justify-content-between align-items-center">
      <span class="unit-font text-break"
        ><h4>Button #{{ index + 1 }}</h4></span
      >
      <span class="text-break">
        <b-button variant="link" class="text-danger px-1 py-0" @click="remove">
          <font-awesome-icon icon="trash-alt" title="Delete" />
        </b-button>
      </span>
    </div>
    <b-row>
      <b-col>
        <b-form-group label="Button type">
          <b-form-select v-model="button.buttonTypeId">
            <b-form-select-option :value="1">Button</b-form-select-option>
            <b-form-select-option :value="2">Quick reply</b-form-select-option>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Order">
          <b-form-input
            type="number"
            v-model="button.sortOrder"
            placeholder="Button order"
          ></b-form-input>
          <small
            class="text-danger"
            v-if="status && isValidated && !button.sortOrder"
            >กรุณากรอกข้อมูลให้ถูกต้อง</small
          >
        </b-form-group></b-col
      >
    </b-row>
    <b-form-group label="Label">
      <b-form-textarea
        v-model="button.label"
        rows="3"
        placeholder="Text here..."
      ></b-form-textarea>
      <small class="text-danger" v-if="status && isValidated && !button.label"
        >กรุณากรอกข้อมูลให้ถูกต้อง</small
      >
    </b-form-group>
    <b-form-group label="Data">
      <b-form-textarea
        v-model="button.data"
        rows="3"
        placeholder="Text here..."
      ></b-form-textarea>
      <small class="text-danger" v-if="status && isValidated && !button.data"
        >กรุณากรอกข้อมูลให้ถูกต้อง</small
      >
    </b-form-group>
  </div></template
>

<script>
export default {
  props: {
    isValidated: {
      required: true,
      type: Boolean,
    },
    button: {
      required: true,
      type: Object,
    },
    index: {
      required: true,
      type: Number,
    },
    buttons: {
      required: true,
      type: Array,
    },
    status: {
      required: true,
      type: Boolean,
    },
  },
  methods: {
    remove() {
      this.buttons.splice(this.index, 1);
    },
  },
};
</script>

<style></style>
